import DashboardBox from '../../components/DashboardBox'
import DashboardSection from '../../components/Cards/DashboardSection'
import PaymentsTable from '../../components/Tables/PaymentsTable'

export default function PaymentsDashboard() {
  const title = 'Ancillary Insurance Programs (AIP) Payment History'

  return (
    <DashboardBox hasMobileFullWidth>
      <DashboardSection name={title} className='table_box_xl_device'>
        <PaymentsTable />
      </DashboardSection>
      <div className='table_box_mobile w-full'>
        <DashboardSection name={title}>
          <div className='w-full h-4'></div>
        </DashboardSection>
        <PaymentsTable displayForMobile />
      </div>
    </DashboardBox>
  )
}
